<div *ngIf="mLocation != null">
    <label style="display:inline">LOCATION: </label>
    <h3 style="display:inline">
        <ng-container *ngFor="let location of mParentLocations">
            <a (click)="locationClicked.emit(location)" style="cursor: pointer">{{location.name}}</a>
            &nbsp;&gt;&nbsp;
        </ng-container> 
        <a (click)="locationClicked.emit(mLocation)" style="cursor: pointer">{{mLocation.name}}</a>
    </h3>
</div>